import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import Teams from '../../api/team'
import Header2 from '../../components/Header2/Header2';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import sImg1 from '../../images/icons/icon_facebook.svg'
import sImg2 from '../../images/icons/icon_twitter_x.svg'
import sImg3 from '../../images/icons/icon_linkedin.svg'
import sImg4 from '../../images/icons/icon_instagram.svg'

const profileStats = [
    { value: '8+', label: 'Years Practical IT Experience' },
    { value: '10', label: 'Core Service Areas' },
    { value: 'Multi', label: 'Regional Office Presence' },
];

const capabilities = [
    'Managed IT Services',
    'Cloud & Infrastructure',
    'Cybersecurity & Compliance',
    'Custom Software Development',
    'Web & Mobile App Development',
    'Data Analytics & Business Intelligence',
    'CRM & Business Applications',
    'AI & Process Automation',
];

const profileHighlights = [
    {
        title: 'Who We Are',
        text: 'Krit Cloud Platforms Sdn Bhd is a Teams Asset Sdn Bhd group company focused on practical IT services for businesses that need reliable cloud, software, data, security and automation support.',
    },
    {
        title: 'Our Experience',
        text: 'Our team brings around 7 to 8 years of hands-on experience across IT operations, cloud platforms, software engineering, cybersecurity, data reporting, automation and delivery support.',
    },
    {
        title: 'Group Strength',
        text: 'As part of Teams Asset Sdn Bhd group, Krit has a stronger business foundation for regional collaboration, project governance, client communication and long-term technology support.',
    },
];

const profileSnapshot = [
    { label: 'Company Type', value: 'IT Services & Digital Solutions' },
    { label: 'Group', value: 'Teams Asset Sdn Bhd' },
    { label: 'Support Model', value: 'Regional and continuous support' },
];

const TeamPage = () => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const DownloadProfilePdf = () => {
        window.print();
    }

    return (
        <Fragment>
            <Header2 />
            <main className="page_content about-page">
                <PageTitle pageTitle={'Company Profile'} pagesub={'Team'} pageTop={'Profile'} />
                <section className="about_section section_space bg-light">
                    <div className="container">
                        <div className="row align-items-center justify-content-lg-between">
                            <div className="col-lg-6 order-lg-last">
                                <div className="profile_snapshot_panel">
                                    <span className="profile_snapshot_label">Company Snapshot</span>
                                    <h3>Krit Cloud Platforms Sdn Bhd</h3>
                                    <p>
                                        Krit Cloud Platforms Sdn Bhd is a Teams Asset Sdn Bhd group company delivering IT services, cloud platforms, software development, cybersecurity, data solutions and automation support.
                                    </p>
                                    <div className="profile_snapshot_list">
                                        {profileSnapshot.map((item) => (
                                            <div className="profile_snapshot_item" key={item.label}>
                                                <span>{item.label}</span>
                                                <strong>{item.value}</strong>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="about_content">
                                    <div className="heading_block">
                                        <div className="heading_focus_text">
                                            Our Company
                                            <span className="badge bg-secondary text-white">Profile</span>
                                        </div>
                                        <h2 className="heading_text">
                                            Meet the Experts Behind Krit Cloud Platforms
                                        </h2>
                                        <p className="heading_description mb-0">
                                            Krit Cloud Platforms Sdn Bhd is backed by a highly skilled team with deep experience in cloud, software, cybersecurity, data, automation and project delivery.
                                        </p>
                                    </div>
                                    <div className="profile_action_group">
                                        <Link onClick={ClickHandler} to={'/contact'} className="btn">
                                            <span className="btn_label" data-text="Work With Us">Work With Us</span>
                                            <span className="btn_icon">
                                                <i className="fa-solid fa-arrow-up-right"></i>
                                            </span>
                                        </Link>
                                        <button type="button" className="btn profile_pdf_btn" onClick={DownloadProfilePdf}>
                                            <span className="btn_label" data-text="Download PDF">Download PDF</span>
                                            <span className="btn_icon">
                                                <i className="fa-solid fa-file-pdf"></i>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="company_profile_section section_space bg-light pt-0">
                    <div className="container">
                        <div className="profile_stats_grid">
                            {profileStats.map((stat) => (
                                <div className="profile_stat_card" key={stat.label}>
                                    <strong>{stat.value}</strong>
                                    <span>{stat.label}</span>
                                </div>
                            ))}
                        </div>

                        <div className="row g-4">
                            {profileHighlights.map((item) => (
                                <div className="col-lg-4" key={item.title}>
                                    <div className="profile_highlight_card">
                                        <h3>{item.title}</h3>
                                        <p>{item.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="company_capability_panel">
                            <div className="row align-items-center justify-content-lg-between">
                                <div className="col-lg-5">
                                    <div className="heading_block mb-lg-0">
                                        <div className="heading_focus_text">
                                            What We Deliver
                                            <span className="badge bg-secondary text-white">Capabilities</span>
                                        </div>
                                        <h2 className="heading_text mb-0">
                                            IT Capability Across Strategy, Build and Support
                                        </h2>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="profile_capability_grid">
                                        {capabilities.map((capability) => (
                                            <div className="profile_capability_item" key={capability}>
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>{capability}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="team_section section_space">
                    <div className="container">
                        <div className="heading_block text-center">
                            <div className="heading_focus_text">
                                <span className="badge bg-secondary text-white">Our Expert</span>
                                Team Members
                            </div>
                            <h2 className="heading_text mb-0">
                                Experienced IT Professionals
                            </h2>
                        </div>

                        <div className="row">
                            {Teams.map((team, tm) => (
                                <div className="col-lg-4 col-md-6 col-sm-6" key={tm}>
                                    <div className="team_block">
                                        <div className="team_member_image">
                                            <Link onClick={ClickHandler} className="image_wrap" aria-label={`${team.name} profile`} to={`/team-single/${team.slug}`}>
                                                <img src={team.tImg} alt={team.name} />
                                                <i className="fa-solid fa-arrow-up-right"></i>
                                            </Link>
                                        </div>
                                        <div className="team_member_info">
                                            <h3 className="team_member_name">
                                                <Link onClick={ClickHandler} to={`/team-single/${team.slug}`}>{team.name}</Link>
                                            </h3>
                                            <h4 className="team_member_designation">{team.title}</h4>
                                            <ul className="social_icons_block unordered_list justify-content-center">
                                                <li>
                                                    <Link onClick={ClickHandler} to={`/team-single/${team.slug}`}>
                                                        <img src={sImg1} alt="Icon Facebook" />
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to={`/team-single/${team.slug}`}>
                                                        <img src={sImg2} alt="Icon Twitter X" />
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to={`/team-single/${team.slug}`}>
                                                        <img src={sImg3} alt="Icon Linkedin" />
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to={`/team-single/${team.slug}`}>
                                                        <img src={sImg4} alt="Icon Instagram" />
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </main>
            <CtaSection />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default TeamPage;
